import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Alert from '@mui/material/Alert';
import TitleBar from "../../../components/TitleBar";
import Confirm from "./Confirm";
import OpenTripForm2 from "./OpenTripForm2";
import OpenTripForm3 from "./OpenTripForm3";
import OpenTripForm4 from "./OpenTripForm4";
import OpenTripForm5 from "./OpenTripForm5";

function OpenTripForm1({
  tripId,
  vtr_nbr,
  permitNbr,
  tripType,
  projectCode,
  returnedErrors,
  onOpen,
}) {
  const [tripid, setTripId] = useState(tripId);
  const [step, setStep] = useState(1);
  const [portcd, setPortCD] = useState({});
  const [etaTripEnd, setEtaTripEnd] = useState(null);
  const [gearType, setGearType] = useState("");

  const values = {
    tripid,
    vtr_nbr,
    permitNbr,
    projectCode,
    tripType,
    portcd,
    etaTripEnd,
    gearType,
  };

  const nextStep = () => {
    if (tripType === "efp") setStep(5);
    else setStep(step + 1);
  };

  const prevStep = () => {
    if (tripType === "efp") setStep(1);
    else setStep(step - 1);
  };

  const goToStep = (step) => {
    setStep(step);
  };

  const handleChange = (input) => (event, reason) => {
    if (input === "trip_id") setTripId(event.target.value);
    else if (input === "port") {
      if (reason) {
        if (reason.hasOwnProperty("id") && reason.hasOwnProperty("label")) {
          setPortCD({ id: reason.id, name: reason.label, state: reason.state });
        }
      } else {
        setPortCD({});
      }
    } else if (input === "gearType") setGearType(event.target.value);
    else if (input === "etaTripEnd") setEtaTripEnd(event);
  };

  const handleConfirm = (values) => {
    onOpen(values);
  };

  return (
    <>
      <TitleBar title="IVR Open Trip Hail" />
      <Grid item xs={12} md={7}>
        {returnedErrors.onSubmitted && (
          <Alert severity="error">{returnedErrors.onSubmitted}</Alert>
        )}
      </Grid>
      <div style={{ width: "100%" }}>
        {
          {
            1: (
              <OpenTripForm2
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            2: (
              <OpenTripForm3
                prevStep={prevStep}
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            3: (
              <OpenTripForm4
                prevStep={prevStep}
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            4: (
              <OpenTripForm5
                prevStep={prevStep}
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            5: (
              <Confirm
                prevStep={prevStep}
                goToStep={goToStep}
                handleConfirm={handleConfirm}
                values={values}
              />
            ),
          }[step]
        }
      </div>
    </>
  );
}

export default OpenTripForm1;
